import React, { useState } from 'react';
import MainLayout from '../../components/layout/MainLayout';
import { MdFileDownload, MdDescription } from 'react-icons/md';
import '../master/MasterData.css';

interface ReportSummary {
  totalEmployees: number;
  totalSalaries: number;
  totalSSS: number;
  totalPhilHealth: number;
  totalPagIBIG: number;
  totalWithholdingTax: number;
}

const GovernmentReports: React.FC = () => {
  const [reportPeriod, setReportPeriod] = useState('2025-03');
  const [activeTab, setActiveTab] = useState<'bir' | 'sss' | 'philhealth' | 'pagibig'>('bir');

  // Sample data - would be fetched from API
  const summary: ReportSummary = {
    totalEmployees: 45,
    totalSalaries: 2875000,
    totalSSS: 151875,      // Employee + Employer contributions
    totalPhilHealth: 95625, // Employee + Employer contributions
    totalPagIBIG: 18000,    // Employee + Employer contributions
    totalWithholdingTax: 242500
  };

  const handleGenerateReport = (reportType: string) => {
    alert(`Generating ${reportType} for period ${reportPeriod}...`);
    // TODO: Call API to generate report
  };

  const handleDownloadReport = (reportType: string) => {
    alert(`Downloading ${reportType}...`);
    // TODO: Download generated report
  };

  return (
    <MainLayout>
      <div className="master-data-page">
        <div className="page-header">
          <div>
            <h2>Government Reports</h2>
            <p className="subtitle">Philippine government statutory reports (BIR, SSS, PhilHealth, Pag-IBIG)</p>
          </div>
        </div>

        <div className="summary-cards">
          <div className="summary-card">
            <div className="summary-icon">👥</div>
            <div className="summary-content">
              <p className="summary-label">Total Employees</p>
              <p className="summary-value">{summary.totalEmployees}</p>
            </div>
          </div>
          <div className="summary-card">
            <div className="summary-icon">💰</div>
            <div className="summary-content">
              <p className="summary-label">Total Salaries</p>
              <p className="summary-value">₱{summary.totalSalaries.toLocaleString()}</p>
            </div>
          </div>
          <div className="summary-card">
            <div className="summary-icon">🏛️</div>
            <div className="summary-content">
              <p className="summary-label">Total Gov't Contributions</p>
              <p className="summary-value">
                ₱{(summary.totalSSS + summary.totalPhilHealth + summary.totalPagIBIG).toLocaleString()}
              </p>
            </div>
          </div>
          <div className="summary-card">
            <div className="summary-icon">📊</div>
            <div className="summary-content">
              <p className="summary-label">Withholding Tax</p>
              <p className="summary-value">₱{summary.totalWithholdingTax.toLocaleString()}</p>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div style={{ marginBottom: '20px', display: 'flex', gap: '15px', alignItems: 'flex-end' }}>
            <div className="form-group" style={{ minWidth: '200px' }}>
              <label>Report Period (Month)</label>
              <input
                type="month"
                value={reportPeriod}
                onChange={(e) => setReportPeriod(e.target.value)}
              />
            </div>
          </div>

          <div className="filter-tabs" style={{ marginBottom: '20px' }}>
            <button
              className={`filter-tab ${activeTab === 'bir' ? 'active' : ''}`}
              onClick={() => setActiveTab('bir')}
            >
              BIR Reports
            </button>
            <button
              className={`filter-tab ${activeTab === 'sss' ? 'active' : ''}`}
              onClick={() => setActiveTab('sss')}
            >
              SSS Reports
            </button>
            <button
              className={`filter-tab ${activeTab === 'philhealth' ? 'active' : ''}`}
              onClick={() => setActiveTab('philhealth')}
            >
              PhilHealth Reports
            </button>
            <button
              className={`filter-tab ${activeTab === 'pagibig' ? 'active' : ''}`}
              onClick={() => setActiveTab('pagibig')}
            >
              Pag-IBIG Reports
            </button>
          </div>

          {activeTab === 'bir' && (
            <div>
              <h3 style={{ marginBottom: '15px', color: '#1a237e' }}>
                Bureau of Internal Revenue (BIR) Reports
              </h3>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdDescription style={{ fontSize: '32px', color: '#1a237e', marginRight: '10px' }} />
                    <div>
                      <h4 style={{ margin: 0 }}>BIR Form 1601-C</h4>
                      <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                        Monthly Remittance Return of Income Taxes Withheld
                      </p>
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Total Withholding Tax</div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e' }}>
                      ₱{summary.totalWithholdingTax.toLocaleString()}
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => handleGenerateReport('BIR Form 1601-C')}
                  >
                    <MdFileDownload /> Generate Form 1601-C
                  </button>
                </div>

                <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdDescription style={{ fontSize: '32px', color: '#1a237e', marginRight: '10px' }} />
                    <div>
                      <h4 style={{ margin: 0 }}>BIR Form 2316</h4>
                      <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                        Annual Certificate of Compensation Payment/Tax Withheld
                      </p>
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Annual Period</div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e' }}>
                      {new Date(reportPeriod).getFullYear()}
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => handleGenerateReport('BIR Form 2316')}
                  >
                    <MdFileDownload /> Generate Form 2316 (All Employees)
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'sss' && (
            <div>
              <h3 style={{ marginBottom: '15px', color: '#1a237e' }}>
                Social Security System (SSS) Reports
              </h3>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdDescription style={{ fontSize: '32px', color: '#1a237e', marginRight: '10px' }} />
                    <div>
                      <h4 style={{ margin: 0 }}>SSS R3 - Monthly Contribution Report</h4>
                      <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                        Monthly schedule of SSS contributions
                      </p>
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Total SSS Contributions</div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e' }}>
                      ₱{summary.totalSSS.toLocaleString()}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                      (Employee + Employer Share)
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => handleGenerateReport('SSS R3')}
                  >
                    <MdFileDownload /> Generate SSS R3 Report
                  </button>
                </div>

                <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdDescription style={{ fontSize: '32px', color: '#1a237e', marginRight: '10px' }} />
                    <div>
                      <h4 style={{ margin: 0 }}>SSS Collection List</h4>
                      <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                        Alphabetical listing of contributions
                      </p>
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Number of Employees</div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e' }}>
                      {summary.totalEmployees}
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => handleGenerateReport('SSS Collection List')}
                  >
                    <MdFileDownload /> Generate Collection List
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'philhealth' && (
            <div>
              <h3 style={{ marginBottom: '15px', color: '#1a237e' }}>
                Philippine Health Insurance Corporation (PhilHealth) Reports
              </h3>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdDescription style={{ fontSize: '32px', color: '#1a237e', marginRight: '10px' }} />
                    <div>
                      <h4 style={{ margin: 0 }}>PhilHealth RF-1</h4>
                      <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                        Monthly Premium Remittance Form
                      </p>
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Total PhilHealth Contributions</div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e' }}>
                      ₱{summary.totalPhilHealth.toLocaleString()}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                      (Employee + Employer Share)
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => handleGenerateReport('PhilHealth RF-1')}
                  >
                    <MdFileDownload /> Generate PhilHealth RF-1
                  </button>
                </div>

                <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdDescription style={{ fontSize: '32px', color: '#1a237e', marginRight: '10px' }} />
                    <div>
                      <h4 style={{ margin: 0 }}>PhilHealth RMEF</h4>
                      <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                        Report of Monthly Employed Members
                      </p>
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Number of Employees</div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e' }}>
                      {summary.totalEmployees}
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => handleGenerateReport('PhilHealth RMEF')}
                  >
                    <MdFileDownload /> Generate RMEF Report
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'pagibig' && (
            <div>
              <h3 style={{ marginBottom: '15px', color: '#1a237e' }}>
                Home Development Mutual Fund (Pag-IBIG) Reports
              </h3>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdDescription style={{ fontSize: '32px', color: '#1a237e', marginRight: '10px' }} />
                    <div>
                      <h4 style={{ margin: 0 }}>Pag-IBIG MCRF</h4>
                      <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                        Monthly Collection Report Form
                      </p>
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Total Pag-IBIG Contributions</div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e' }}>
                      ₱{summary.totalPagIBIG.toLocaleString()}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                      (Employee + Employer Share)
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => handleGenerateReport('Pag-IBIG MCRF')}
                  >
                    <MdFileDownload /> Generate Pag-IBIG MCRF
                  </button>
                </div>

                <div style={{ padding: '20px', border: '1px solid #ddd', borderRadius: '8px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <MdDescription style={{ fontSize: '32px', color: '#1a237e', marginRight: '10px' }} />
                    <div>
                      <h4 style={{ margin: 0 }}>Pag-IBIG Member List</h4>
                      <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
                        List of all contributing members
                      </p>
                    </div>
                  </div>
                  <div style={{ marginBottom: '10px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px' }}>
                    <div style={{ fontSize: '12px', color: '#666' }}>Number of Members</div>
                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#1a237e' }}>
                      {summary.totalEmployees}
                    </div>
                  </div>
                  <button
                    className="btn btn-primary"
                    style={{ width: '100%' }}
                    onClick={() => handleGenerateReport('Pag-IBIG Member List')}
                  >
                    <MdFileDownload /> Generate Member List
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default GovernmentReports;
